import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { CategoryListItemExt } from 'api/types';
import { CategoriesListType, DocumentCategory } from 'types';

import { API_HANDLERS } from '../../apiHandlers';

interface UseCategoryListQueryReturn {
  categoryMap: CategoriesListType;
  categoriesList: CategoryListItemExt[];
  isLoading: boolean;
}

export function useCategoriesListQuerywithVisbility(
  visibility?: boolean,
): UseCategoryListQueryReturn {
  const { data, isLoading } = useQuery(['document_categories', visibility], () =>
    API_HANDLERS.CATEGORY.GET_LIST({ ...(visibility && { visibility }) }),
  );

  const categoriesList = useMemo(
    () =>
      data?.data?.data?.map((cat: { title: string }) => {
        return {
          ...cat,
          tag: cat?.title?.toLowerCase(),
          created_by: {
            id: 'Sample User ID',
            first_name: 'Sample',
            last_name: 'User',
          },
        };
      }) || [],
    [data],
  );

  const categoryMap: CategoriesListType = useMemo(
    () =>
      categoriesList.reduce((acc: CategoriesListType, category: DocumentCategory) => {
        acc[`${category.title.toLowerCase()}`] = {
          ...category,
          label: category.title,
          tag: category.title.toLowerCase(),
          created_by: {
            id: 'Sample User ID',
            firstName: 'Sample',
            lastName: 'User',
            email: 'sample.user@example.com',
          },
        };
        return acc;
      }, {}),
    [categoriesList],
  );

  return {
    categoryMap,
    categoriesList,
    isLoading,
  };
}
